import { CheckboxNode, b } from '../const';
const DEFAULT_LABEL_PLACEHOLDER = 'Checkbox';
export const getSpec = (opts, placeholder) => {
    var _a, _b;
    return ({
        [CheckboxNode.Checkbox]: {
            group: 'block',
            content: `${CheckboxNode.Input} ${CheckboxNode.Label}`,
            selectable: true,
            allowSelection: false,
            parseDOM: [],
            attrs: {
                class: { default: b() },
            },
            toDOM(node) {
                return ['div', node.attrs, 0];
            },
            complex: 'root',
        },
        [CheckboxNode.Input]: {
            group: 'block',
            parseDOM: [],
            attrs: {
                type: { default: 'checkbox' },
                id: { default: null },
                checked: { default: null },
            },
            toDOM(node) {
                return ['div', node.attrs];
            },
            selectable: false,
            allowSelection: false,
            complex: 'leaf',
        },
        [CheckboxNode.Label]: {
            content: 'inline*',
            group: 'block',
            parseDOM: [
                {
                    tag: `span[class="${b('label')}"]`,
                    getAttrs: (node) => ({
                        for: node.getAttribute('for') || '',
                    }),
                },
            ],
            attrs: {
                for: { default: null },
            },
            escapeText: false,
            placeholder: {
                content: (_b = (_a = placeholder === null || placeholder === void 0 ? void 0 : placeholder[CheckboxNode.Label]) !== null && _a !== void 0 ? _a : opts === null || opts === void 0 ? void 0 : opts.checkboxLabelPlaceholder) !== null && _b !== void 0 ? _b : DEFAULT_LABEL_PLACEHOLDER,
                alwaysVisible: true,
            },
            toDOM(node) {
                return ['span', Object.assign(Object.assign({}, node.attrs), { class: b('label') }), 0];
            },
            selectable: false,
            allowSelection: false,
            disableGapCursor: true,
            complex: 'leaf',
        },
    });
};
